var $ = global.jQuery = global.$;

require('../third-party/jquery.highlight.js');

var _isEqual = require('lodash/lang/isEqual');

var Filters = require('./Filters');

var SearchFilters = Filters.extend({
  init: function() {
    var self = this;

    this.$searchTerm = this.$el.find('[data-search-term]');

    this.$el.on('filters:AllUpdated',function(event,response,request){
      if (response.Value.SearchTerm && response.Value.SearchTerm !== ''){
        self.updateSearchTerm(response.Value.SearchTerm,response.Value.Items.length);
      }
    });

    this.$el.on('submit',function(event){
      event.preventDefault();
      if (!_isEqual(self.currentCriteria, self.fields)) {
        self.currentCriteria = $.extend(true, {}, self.fields);
        self.getItems();
      }
    });

    this._super();

    this.$messageAppendArea = this.$searchTerm;

  },
  updateSearchTerm: function(term,itemsLength){
    var self = this;
    if (itemsLength === 0){
      this.showMessage('No results returned for <span>&ldquo;' + term + '&rdquo;</span>');
    } else {
      this.showMessage('Search results for <span>&ldquo;' + term + '&rdquo;</span>');
      setTimeout(function(){
        self.$itemArea.find('.search-result').each(function(){
          $(this).highlight(term,{
            wordsOnly: true
          });
        });
      },itemsLength * 100);
    }
  }
});

module.exports = SearchFilters;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/SearchFilters.js
// module id = 261
// module chunks = 0 1